/**
* file : TournamentRelated/Common/Winning.jsx
* 설명 : 실시간 당첨 내역
*/

import icon1 from "assets/images/icon1.png"

import { Fnc } from "common/globals";
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { SSE } from 'components/Common/ApiCall';

export default function Winning(props) {
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  // 데이터
  const [datas, setData] = useState();
  // SSE 통신
  useEffect(() => {
    const { start, stop } = SSE();

    start(`/win?tournament_idx=${props.tournament_idx}`,
    (result) => {
      setData(result);
    }, (err) => {
      console.error('SSE Win 통신 중 오류:', err);
    })

    return () => {
      stop();
    };
  }, []);

  return (
    !Fnc.Empty(datas) && <div className="box">
      <h3><span><img src={icon1} alt="icon1" /></span>실시간 당첨 현황</h3>
      <div className="realtime">
        <ul>
          {
            datas.map((data, index) => (
              <li key={index}>
                <p><img src={props.img} alt={`${props.img}_${index}`} /></p>
                <div>
                  <p>
                    {data.user_id}
                    {data.user_idx === info.idx && <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -900 960 960" width="20px" fill="#0D7EE7"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" /></svg>}
                  </p>
                  <p>{props.tournament_game_name}</p>
                  <p className="txt_org"><span className="won"></span>{data.amount.toLocaleString()}</p>
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}